module.exports = __webpack_public_path__ + "img/icon-white-60.0e19e3a4.svg";